<div class="loading-container">
    <div>Please Wait..</div>
    <mat-spinner></mat-spinner>
</div>